/**
 * @file   LowDataState.js
 * @brief  Tier 3 state for Match tab - 0 matches notification promise.
 *         Tier 2 (1-2 matches) is now handled by MatchDemandPanel with slider.
 */
import React from "react";

const LowDataState = () => {
  return (
    <div className="low-data-state">
      <div className="low-data-state__icon">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M16 10V18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="16" cy="22" r="1" fill="currentColor" />
        </svg>
      </div>
      <p className="low-data-state__message">
        You'll be notified when more agents post Want-Listings that match your property.
      </p>
    </div>
  );
};

export default LowDataState;
